import { useMappedConstants } from "@/app/hooks/useMappedConstants";
import clsx from "clsx";
import { startCase } from "lodash";

const BookingHistoryColor: React.FC<{
  bookingStatus: string;
}> = (props) => {
  const { bookingHistoryColors } = useMappedConstants();
  const statusClassName = bookingHistoryColors[props?.bookingStatus?.toLowerCase()];
  return (
    <div
      className={clsx(
        "justify-center gap-1.5 flex-row items-center opacity-100 px-3 py-1.5 rounded-[20px] flex",
        statusClassName,
      )}
    >
      <span className="text-xs max-xl:text-[10px] font-normal  text-center tracking-[0px]">
        {startCase(props?.bookingStatus)}
      </span>
    </div>
  );
};

export default BookingHistoryColor;
